export const list = {
  role_name: {
    name: '角色名称',
    key: 'role_name',
    show: true,
  },
  category: {
    name: '角色类型',
    key: 'category',
    show: true,
  },
  create_time: {
    name: '创建时间',
    key: 'create_time',
    show: true,
  },
  update_time: {
    name: '更新时间',
    key: 'update_time',
    show: true,
  }
};
